import { Component, ComponentInterface, h, Host, JSX } from '@stencil/core';
@Component({
  tag: 'wb-grid-row',
  styleUrl: 'grid-row.scss',
  shadow: true,
})
export class GridRowComponent implements ComponentInterface {
  public render(): JSX.Element {
    return (
      <Host>
        <slot />
      </Host>
    );
  }
}
